















































































































































import queries from "@/gql/queries.coffee"
import VotreConsultant from '@/components/VotreConsultant'
import moment from 'moment'
import settings from '@/settings.coffee'
import EstablishmentStateInformationNeeded from "@/components/review_states/EstablishmentStateInformationNeeded.vue"
import EstablishmentStateAnswerWriting from "@/components/review_states/EstablishmentStateAnswerWriting.vue"
import EstablishmentStateAnswerTextValidation from "@/components/review_states/EstablishmentStateAnswerTextValidation.vue"
import EstablishmentStateSignalingWriting from '@/components/review_states/EstablishmentStateSignalingWriting'
import EstablishmentStateSignalingSent from '@/components/review_states/EstablishmentStateSignalingSent'
import EstablishmentStateClassified from '@/components/review_states/EstablishmentStateClassified'
import EstablishmentStateAnswerPublished from '@/components/review_states/EstablishmentStateAnswerPublished.vue'
import EstablishmentStateAnswerAccepted from '@/components/review_states/EstablishmentStateAnswerAccepted'
import EstablishmentStateWaitingForInformation from '@/components/review_states/EstablishmentStateWaitingForInformation'
export default {
  name: "GatheringReviewDetail"
  components:{
    VotreConsultant
    EstablishmentStateInformationNeeded
    EstablishmentStateWaitingForInformation
    EstablishmentStateAnswerWriting
    EstablishmentStateAnswerTextValidation
    EstablishmentStateSignalingWriting
    EstablishmentStateSignalingSent
    EstablishmentStateClassified
    EstablishmentStateAnswerPublished
    EstablishmentStateAnswerAccepted
  }
  data: ()->
    detailedReview: null
    conn_info: null
  props:
    establishment: Object
    review: Object
  computed:
    settings:()->
      return settings
  methods:
      stateUpdated: ()->
          vm = this
          response = await queries.run("get_review_detail_for_establishment", [@$route.params.review_uid])
          if response.ok
            @detailedReview = response.body.data.review
          
  mounted: ()->
    vm = this
    response = await queries.run("get_review_detail_for_establishment", [@$route.params.review_uid])
    if response.ok
      @detailedReview = response.body.data.review
    queries.run('get_connection_for', [@detailedReview.platform.uid, @detailedReview.establishment.uid]).then (resp)->
      #console.log("reloadConnection", resp.data.data.connection_set)
      if resp.data.data.connection_set.length > 0
          vm.conn_info = resp.data.data.connection_set[0]
      else
          vm.conn_info = null
      
      
}
